
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { VacationMascot } from "./VacationMascot";

interface ResultsHeaderProps {
  onBack: () => void;
  personalizedMessage: string;
}

export const ResultsHeader = ({ onBack, personalizedMessage }: ResultsHeaderProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Button variant="outline" onClick={onBack} className="flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          Terug naar zoeken
        </Button>
        
        <div className="flex justify-end">
          <VacationMascot size="small" />
        </div>
      </div>
      
      <div className="text-center">
        <p className="text-lg font-medium text-gray-800">
          {personalizedMessage}
        </p>
      </div>
    </div>
  );
};
